var render = function render(){var _vm=this,_c=_vm._self._c;return _c('pui-theme-provider',{staticClass:"pui-wrapper",attrs:{"id":"evo-app","theme":_vm.platformTheme}},[(_vm.showAppSpinner)?_c('pui-common-spinner',{attrs:{"message":_vm.loadingMessage,"fullscreen":""}}):_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }